exports.linkResolver = (doc) => {
  if (doc.uid !== 'index' && doc.type === 'page') return `/${doc.uid}/`
  if (doc.type === 'project') return `/projects/${doc.uid}/`
  if (doc.type === 'blogpost') return `/news/${doc.uid}/`
  if (doc.type === 'member_page') return `/dashboard/${doc.uid}/`
  if (doc.type === 'publication') return `/publications/${doc.uid}/`
  return '/'
}
